import { Component, Input, OnInit } from '@angular/core';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-display-rubrique-status-on-off',
  templateUrl: './display-rubrique-status-on-off.component.html',
  styleUrls: ['./display-rubrique-status-on-off.component.scss'],
  imports: [IonItem, IonLabel, IonList, TranslatePipe],
})
export class DisplayRubriqueStatusOnOffComponent {
  @Input() title: string = '';
  @Input() value: boolean = false;

  constructor() {}
}
